import { DeliveryMethodNames, DeliveryMethods } from '@eo-storefronts/eo-core'
import { MouseEvent } from 'react'
import ToggleButtonGroup from '~/src/components/mui-wrappers/styled/ToggleButtonGroup'
import { useEoState, useEoValue } from '~/src/hooks/useEoState'
import { CHECKOUT_FORM_STATE, CheckoutFormState, FROZEN_DELIVERY_METHOD_STATE } from '~/src/stores/checkout'
import { FIRM_SELECTOR } from '~/src/stores/firm'
import DeliveryMethodsSwitchButton from './DeliveryMethodsSwitchButton'

const DeliveryMethodsSwitch = () => {
  const firm  = useEoValue(FIRM_SELECTOR)
  const frozenDeliveryMethod = useEoValue(FROZEN_DELIVERY_METHOD_STATE)
  const [ checkoutState, setCheckoutForm ] = useEoState(CHECKOUT_FORM_STATE)

  const handleOnChange = (event: MouseEvent, value: keyof DeliveryMethods) => {
    if (value === null || frozenDeliveryMethod) {
      return
    }

    setCheckoutForm((state: CheckoutFormState) => ({
      ...state,
      delivery_method: {
        ...state.delivery_method,
        asap: false,
        timeslotId: null,
        method: value
      }
    }))
  }

  return (
    <ToggleButtonGroup
      value={checkoutState.delivery_method.method}
      exclusive
      onChange={handleOnChange}
    >
      <DeliveryMethodsSwitchButton value={DeliveryMethodNames.PICKUP} />
      <DeliveryMethodsSwitchButton value={DeliveryMethodNames.DELIVERY} />
      {
        firm?.settings.delivery_methods && Object.keys(firm.settings.delivery_methods).map((method: string) => {
          if (
            method === DeliveryMethodNames.PICKUP
            || method === DeliveryMethodNames.DELIVERY
          ) {
            return []
          }

          return <DeliveryMethodsSwitchButton key={method} value={method} />
        })
      }
    </ToggleButtonGroup>
  )
}

export default DeliveryMethodsSwitch
